import React from 'react';

var formatter = new Intl.NumberFormat('se-SV', {
  style: 'currency',
  currency: 'SEK',
  minimumFractionDigits: 0,
});

export default ({value}) => {
  if (!value)
  {
    value = 0;
  }
  var formated = formatter.format(value).replace(/,/g,' ').replace(/[a-zA-Z]+/,'').replace(/[-]+/,' - ');
  return (
    <span className="Price ">{formated} kr</span>
  )
}



// WEBPACK FOOTER //
// ./src/components/Formaters/Price.jsx